<template>
  <Section class="p-4 sm:p-6 lg:p-10">
    <div class="p-4 pt-6 mb-6 bg-white rounded-lg sm:p-6 md:mb-10 md:pt-8">
      <div class="mb-6 md:mb-8 flex flex-col items-center">
        <PromoLogo full class="logo mb-2" to="/" />

        <Button class="link text-support-lighter xxs" to="/"
          ><v-icon name="chevron-left" scale="0.7" class="mr-1" /> Back to
          Home</Button
        >
      </div>

      <h2
        class="text-center text-lg md:text-2xl lg:text-3xl mb-2 md:mb-4 lg:mt-6"
      >
        Get More Features!
      </h2>

      <p class="intro-text">
        With our flexible email based pricing, you’ll never pay for more than
        you need.
      </p>

      <p class="intro-text font-lato text-support-lighter">
        Your current subscriber count is
        <span class="font-bold">{{
          Number(subscriberCount).toLocaleString()
        }}</span
        >.

        <Button
          class="link xxs text-brand mx-auto font-sans mt-1"
          @click="showDetails = !showDetails"
        >
          {{ showDetails ? "Hide" : "Show" }} how this is calculated?
        </Button>
      </p>

      <div v-if="showDetails" class="additional-details">
        <p>
          Your current customer count is <strong>{{ customerCount }}</strong
          >.
        </p>

        <p>
          Your subscriber count is not the same as your customer count.
        </p>
        <p>
          We only send to users that have opted-in to receive marketing from
          your store.
        </p>

        <p>
          For more information you can check out the following help article
          <a
            href="http://help.promo.ai/article/who-does-the-app-send-to/"
            target="_blank"
            >Who does the app send to?</a
          >
        </p>
      </div>
      <!-- .additional-details -->

      <PackageSelector class="mt-4 lg:mt-6" />

      <FAQs />
    </div>
  </Section>
</template>

<script>
import { Account } from "@/graphql/queries";
import Section from "@/components/UI/Section";
import FAQs from "@/components/FAQs/FAQs";
import PackageSelector from "@/components/Account/PackageSelector";

export default {
  apollo: {
    $query: {
      fetchPolicy: "cache-first",
    },
    account: {
      query: Account,
      update: (data) => data.account,
    },
  },
  name: "Plans",
  components: { FAQs, PackageSelector, Section },
  data() {
    return {
      showDetails: false,
    };
  },
  computed: {
    customerCount() {
      return this.account?.subscribers?.customerCount;
    },
    subscriberCount() {
      return this.account?.subscribers?.subscriberCount;
    },
  },
};
</script>

<style scoped>
.logo {
  @apply block mx-auto mb-2;
  max-width: 144px;
}

.intro-text {
  @apply text-center text-sm text-support-lighter mb-2 max-w-xs mx-auto;

  @screen md {
    @apply text-base max-w-md;
  }
}

.additional-details {
  @apply max-w-lg mx-auto text-center text-xs text-support-lighter;

  p {
    @apply mb-2;

    &:last-child {
      @apply mb-0;
    }
  }
}
</style>
